import React, { useEffect, useRef, useState } from 'react';
import { Sec, SH } from '../components/Shared';
import { PRIVACY_SECTIONS, MEMBERSHIP_SECTIONS } from '../data/websiteData';

const LegalPage = ({ title, type }) => {
  const [active, setActive] = useState('');
  const sections = type === 'privacy' ? PRIVACY_SECTIONS : MEMBERSHIP_SECTIONS;
  const sectionRefs = useRef({});
  const observerRef = useRef(null);

  useEffect(() => {
    observerRef.current = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) setActive(entry.target.id);
      });
    }, { threshold: 0.5, rootMargin: '-100px 0px -100px 0px' });

    sections.forEach(s => {
      const el = sectionRefs.current[s.id];
      if (el) observerRef.current.observe(el);
    });

    return () => { if (observerRef.current) observerRef.current.disconnect(); };
  }, [sections]);

  return (
    <div className="af">
      <Sec py={160} bg="var(--grad-hero)">
        <div className="legal-grid" style={{ display: 'grid', gridTemplateColumns: '280px 1fr', gap: 64, alignItems: 'start' }}>
          <aside className="hide-m" style={{ position: 'sticky', top: 120 }}>
            <div className="eyebrow">Protocol sync</div>
            <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 32, fontWeight: 800, color: 'var(--on-surface)', marginBottom: 32, letterSpacing: 'var(--ls-tight)' }}>{title}</h1>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
              {sections.map(s => (
                <button 
                  key={s.id} 
                  onClick={() => sectionRefs.current[s.id]?.scrollIntoView({ behavior: 'smooth', block: 'center' })} 
                  style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: 12, 
                    padding: '10px 16px', 
                    borderRadius: 4, 
                    background: active === s.id ? 'var(--surface-container-low)' : 'transparent', 
                    border: 'none', 
                    cursor: 'pointer', 
                    textAlign: 'left', 
                    transition: 'all .2s' 
                  }}
                >
                  <div style={{ width: 6, height: 6, borderRadius: '50%', background: active === s.id ? 'var(--primary)' : 'var(--slate-200)', transition: 'all .3s' }} />
                  <span style={{ fontSize: 13, fontWeight: active === s.id ? 700 : 500, color: active === s.id ? 'var(--primary)' : 'var(--slate-500)' }}>{s.title.split('. ')[1]}</span>
                </button>
              ))}
            </div>
          </aside>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: 80 }}>
            <div className="au">
              <SH eyebrow="Compliance Framework" title={title} sub={`Official governing standards for ICDITC operational infrastructure. Ref v2.4.0`} center={false} />
            </div>
            {sections.map((s, i) => (
              <div key={s.id} id={s.id} ref={el => sectionRefs.current[s.id] = el} className="au" style={{ animationDelay: `${i * 0.05}s` }}>
                <h3 style={{ fontFamily: 'var(--font-display)', fontSize: 22, fontWeight: 700, color: 'var(--on-surface)', marginBottom: 24, display: 'flex', alignItems: 'center', gap: 16 }}>
                  <span style={{ color: 'var(--primary)', opacity: 0.2, fontSize: 16 }}>{String(i + 1).padStart(2, '0')}</span> 
                  {s.title.split('. ')[1]}
                </h3>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                  {s.body.map((p, j) => (
                    <p key={j} style={{ fontSize: 16, color: 'var(--on-surface-variant)', lineHeight: 1.8 }}>{p}</p>
                  ))}
                </div>
                <div style={{ height: 2, background: 'var(--surface-container-low)', marginTop: 48, width: 40 }} />
              </div>
            ))}
          </div>
        </div>
      </Sec>
    </div>
  );
};

export default LegalPage;
